import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {TimelineMax} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Mental} from "../Mental";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class MentalHelper extends Helper {
    public static timeLineKiller(tl: TimelineMax, tlR?: TimelineMax, forceEnd: boolean = false): TimelineMax {
        if (!tl) return tlR ? tlR : tl;
        if (forceEnd) tl.totalProgress(1);
        tl.pause();
        tl.kill();
        tl.clear();
        return tlR ? tlR : tl;
    }

    public static copyLocalPosition(objToSet: PIXI.DisplayObject, objToMimic: PIXI.DisplayObject): PIXI.Point {
        return objToSet.parent.toLocal(objToSet.parent.position, objToMimic);
    }

    public static getDistance(p1: PIXI.Point, p2: PIXI.Point): number {
        const xDist: number = p2.x - p1.x;
        const yDist: number = p2.y - p1.y;
        return Math.sqrt(Math.pow(xDist, 2) + Math.pow(yDist, 2));
    }

    public static getAngleInDegree(pos1: number[], pos2: number[]): number {
        let angle: number = Math.atan2(pos1[0] - pos2[0], pos1[1] - pos2[1]);
        angle = angle < 0 ? (2 * Math.PI + angle) : angle;
        const finalAngle: number = angle * (180 / Math.PI);
        return 360 - 90 - finalAngle; //pixi object use clockwise angle.
    }

    public static createSprite(sourceName: string, parent?: PIXI.Container, pos?: number[]): TimelineSprite {
        const sprite: TimelineSprite = new TimelineSprite(Mental.assetLoader.getTextures(sourceName));
        sprite.name = sourceName;
        if (pos && pos.length) {
            sprite.position.set(pos[0], pos[1]);
        }
        sprite.anchor.set(0.5);
        parent && parent.addChild(sprite);
        return sprite;
    }

    public static getRandomIntInRange(min: number, max: number, fractionDigits: number = 0): number {
        return Number((min + (max - min) * Math.random()).toFixed(fractionDigits));
    }

    public static getBuyFeaturePrice(): number {
        let betLevel: string = Mental.apiPlugin.freeBets.hasFreeBets() ? Mental.apiPlugin.freeBets.getBet() : Mental.apiPlugin.betLevel.getLevel();
        let price: number = Mental.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (Mental.model.data.wasFeatureBuy) {
            for (let index = 0; index < Mental.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Mental.model.initData.featureBuyTimesBetValue[index].name === Mental.model.buyFeatureName) {
                    price *= Mental.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    public static isWinBelowStake(): boolean {
        return Mental.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (Mental.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    public static isSingleWinBelowStake(): boolean {
        return Mental.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (Mental.model.gameData.totalBetWayWinnings <= Mental.model.gameData.playedBetValue);
    }
}